import React from "react";
import Sidebar from "react-sidebar";
import { AlignJustify } from "react-feather";
import logouticon from "components/Navbars/img/logout.png";
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: true,
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
  }

  onSetSidebarOpen(open) {
    this.setState({ sidebarOpen: open });
  }

  render() {
    return (
      <Sidebar
        rootClassName="h-0"
        pullLeft
        sidebarClassName="mob-sidebar-60 mob-rounded-none rounded-t-l-12px p-4 fixed"
        sidebar={
          <div>
            <div className="flex items-center px-2">
              <AlignJustify className="text053D6D mr-4" />
              <h1 className="font-bold fsize20 xs-fsize18">Menu</h1>
            </div>

            <div>
              <div className="mt-4">
                <div className="py-3">
                  <p className="font-bold px-4 fsize13">Jobs</p>
                </div>
                <p className="border-b-EAEBED"></p>
                <div className="py-3">
                  <p className="font-bold px-4   fsize13">Our Courses</p>
                </div>
                <p className="border-b-EAEBED"></p>

                <div className="py-3">
                  <p className="font-bold px-4   fsize13">Programmes</p>
                </div>
                <p className="border-b-EAEBED"></p>

                <div className="py-3">
                  <p className="font-bold px-4   fsize13">Know Us More</p>
                </div>
                <p className="border-b-EAEBED"></p>

                <div className="py-3">
                  <p className="font-bold px-4   fsize13">What's New</p>
                </div>
                <p className="border-b-EAEBED"></p>

                <div className="py-3">
                  <p className="font-bold px-4   fsize13">iTV</p>
                </div>
                <p className="border-b-EAEBED"></p>

                <div className="py-3">
                  <p className="font-bold px-4   fsize13">Contact Us</p>
                </div>
              </div>

              <div className="fixed p-6 bottom-0 left-0 flex items-center w-full">
                <div className="mr-2">
                  <img src={logouticon} />
                </div>
                <p className="font-bold    fsize13">Logout</p>
              </div>
            </div>
          </div>
        }
        open={this.props.ShowMobileHamburger}
        onSetOpen={this.onSetSidebarOpen}
        styles={{ sidebar: { background: "white" } }}
      >
        {/* <button onClick={() => this.onSetSidebarOpen(true)}>
          Open sidebar
        </button> */}
      </Sidebar>
    );
  }
}

export default App;
